<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>Aneks nr 1</strong>
</p>
<ol>
    <li>Zleceniobiorca przyjmuje do wiadomości i godzi się na niestosowanie wprost zakazu konkurencji opisanego w § 9 w przypadkach, kiedy Zleceniobiorca świadczy usługi edukacyjne objęte Umową dla następujących podmiotów:
        <table style="margin-top: 30px; margin-bottom: 30px;">
            <tbody>
                <tr>
                    <td style="border: 1px solid; padding: 3px 0 3px 5px;"><b>Nazwa podmiotu</b></td>
                    <td style="border: 1px solid; padding: 3px 0 3px 5px;"><b>Ilość godzin w tygodniu</b></td>
                    <td style="border: 1px solid; padding: 3px 0 3px 5px;"><b>Dodatkowe uwagi</b></td>
                </tr>
                <tr>
                    <td style="border: 1px solid; padding: 3px 0 3px 5px;">{{ podmiot }}</td>
                    <td style="border: 1px solid; padding: 3px 0 3px 5px;">{{ iloscGodzin }}</td>
                    <td style="border: 1px solid; padding: 3px 0 3px 5px;">{{ dodatkoweUwagi }}</td>
                </tr>
            </tbody>
        </table>
    </li>
    <li>W przypadku zmiany warunków opisanych w p. 1 niniejszego Aneksu, Zleceniobiorca jest zobowiązany do poinformowania Zleceniodawcy o aktualnej sytuacji możliwie najszybciej, nie później niż w ciągu 3 dni kalendarzowych. Zleceniobiorca musi zaakceptować nowe warunki wyłączenia z zakazu konkurencji i strony Umowy muszą podpisać nowy, aktualny Aneks. Brak spełnienia wyżej opisanego obowiązku informacyjnego po stronie Zleceniodawcy może skutkować rozwiązaniem Umowy ze skutkiem natychmiastowym oraz zastosowaniem ustaleń opisanych w § 9 p. 6 niniejszej Umowy.</li>
</ol>

<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">{{ zamawiajacy }}</span><br>
        <span style="margin-left: 0%;"><b>Podpis Zleceniodawcy</b></span>
    </div>
    <div class="right-cointainer">
        {{ imieNazwisko }}<br>
        <span style="margin-left: 0%;"><b>Podpis Zleceniobiorcy</b></span>
    </div>
</div>

  </td></tr>
  </tbody></table>

  </v-container>
</template>

<script>
export default {
  name: 'UmowaAneksProfi2023',
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      pesel: '',
      zamieszkany: '',
      zmiana: '',
      dataAneks: '',
      numerUmowy: '',
      dataPodpisania: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}
table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}
th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
ul.dashed {
  list-style-type: "- ";
  margin: 0;
}
.underline {
  text-decoration: underline;
}
.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}
#oswiadczenie {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaAneksProfi2023.vue